<template>
  <div class="pagebox">
    
    <!-- 动态展示模块组件 -->
    <component :is="item.ModuleCode" :ModuleData="GetModuleByModuleName(item.ModuleCode)" :ModuleDataHot="GetModuleByModuleName2(item.ModuleCode)" :ModuleDataType="GetModuleByModuleName3(item.ModuleCode)" :ModuleName="item.ModuleName" v-for="(item,index) in ModuleItemList" :key="index" class="wow fadeIn" data-wow-duration="0.8s" data-wow-delay="0s" data-wow-offset="100"></component>

  </div>
</template>
<script>
//引入wowjs
import API from "@/api/config";
import {WOW} from 'wowjs';
import 'wowjs/css/libs/animate.css';
import Top from '@/components/header/Top.vue';
import Head from '@/components/header/Header.vue';
import HeadMenu from '@/components/header/HeadMenu.vue';
import Banner from "./components/home/HBanner.vue";
import Notice from "./components/home/HNotice.vue";
import ToolBox from "./components/home/HBotton.vue";
import News from "./components/home/HNews.vue";
import Planner from "./components/home/HExpert.vue";
import UpgradeNews from "./components/home/HRiseNews.vue";
import HotSpecialty from "./components/home/HSpeciality.vue";
import HotSchool from "./components/home/HSchool.vue";
import Video from "./components/home/HVideo.vue";
import RecommendProfession from "./components/home/HRecommend.vue";
import FriendLink from "./components/home/HFriend.vue";
import Publicize from "./components/home/HContent.vue";
import BottomMenu from '@/components/footer/BottomMenu.vue';
import Contact from '@/components/footer/Contact.vue';
import Bottom from '@/components/footer/Bottom.vue';
import {getStore} from '@/utils/utils';
export default{
  components: {
    Top,
    Head,
    HeadMenu,
    Banner,
    Notice,
    ToolBox,
    News,
    Planner,
    UpgradeNews,
    HotSpecialty,
    HotSchool,
    Video,
    RecommendProfession,
    FriendLink,
    Publicize,
    BottomMenu,
    Contact,
    Bottom
  },
  data(){
    return{
      ModuleItemList:[],
      ModuleData:[],
    }
  },
  mounted(){
    API.Web.GetHomeData().then(res => {
      if(res.Code===0 && res.Data!=null){
        this.ModuleData = res.Data;
        let data = getStore('ModuleList');
        if(data!=null&&data!=undefined&&data!=''&&data!=[]){
          this.ModuleItemList = JSON.parse(data);
        }
      }
    });
    new WOW({live:false}).init();//动画初始化
  },
  methods:{
    GetModuleByModuleName(code){
      let arr = [];
      if(code=='Notice'){
        arr = this.ModuleData.NoticeList;
      }
      if(code=='Banner'){
        arr = this.ModuleData.AdList;
      }
      if(code=='News'){
        arr = this.ModuleData.NewsInfoList;
      }
      if(code=='Planner'){
        arr = this.ModuleData.TeacherList;
      }
      if(code=='HotSpecialty'){
        arr = this.ModuleData.MajorHotList;
      }
      if(code=='HotSchool'){
        arr = this.ModuleData.CollegeList;
      }
      if(code=='Video'){
        arr = this.ModuleData.VideoList;
      }
      if(code=='RecommendProfession'){
        arr = this.ModuleData.ProfessionRecommendList;
      }
      if(code=='FriendLink'){
        arr = this.ModuleData.FriendLinkList;
      }
      return arr;
    },
    GetModuleByModuleName2(code){
      let arr = [];
      if(code=='News'){
        arr = this.ModuleData.NewsHotList;
      }
      if(code=='RecommendProfession'){
        arr = this.ModuleData.ProfessionHotList;
      }
      if(code=='Video'){
        arr = this.ModuleData.VideoHotList;
      }
      return arr;
    },
    GetModuleByModuleName3(code){
      let arr = [];
      if(code=='News'){
        arr = this.ModuleData.NewsCategoryList;
      }
      return arr;
    },
  }
}
</script>